import type { SVGProps } from 'react';

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

export function IconEye(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2} {...p}>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function IconEyeOff(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2} {...p}>
      <path d="M3 3l18 18" />
      <path d="M10.6 5.1A10.8 10.8 0 0 1 12 5c6.5 0 10 7 10 7a17.6 17.6 0 0 1-3.1 4.1M6.5 6.6C4 8.3 2 12 2 12s3.5 7 10 7a9.7 9.7 0 0 0 4-.8" />
      <path d="M9.5 10a3 3 0 0 0 4.2 4.2" />
    </svg>
  );
}

export function IconUp(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2.2} {...p}>
      <path d="M18 15l-6-6-6 6" />
    </svg>
  );
}

export function IconDown(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2.2} {...p}>
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export function IconLock(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2} {...p}>
      <rect x="4" y="8" width="16" height="12" rx="2" />
      <path d="M8 8V6a4 4 0 0 1 8 0v2" />
    </svg>
  );
}

export function IconDesktop(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2} {...p}>
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8M12 16v4" />
    </svg>
  );
}

export function IconMobile(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2} {...p}>
      <rect x="7" y="3" width="10" height="18" rx="2" />
      <path d="M11 18h2" />
    </svg>
  );
}
